<div *ngIf="issueType$ | ngrxPush as issueType">
    <img [src]="{ light: 'assets/images/no-access.svg', dark: 'assets/images/no-access-dark.svg' } | themeVariant" alt="" />

    <ng-container [ngSwitch]="issueType">
        <h2 *ngSwitchCase="ConnectionIssueType.InvalidClient">{{ "dtmUi.connectionIssue.invalidClientMessage" | transloco }}</h2>
        <h2 *ngSwitchCase="ConnectionIssueType.CannotAcceptConnection">
            {{ "dtmUi.connectionIssue.cannotAcceptConnectionMessage" | transloco }}
        </h2>
    </ng-container>
</div>
